var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25C6.62 2.25 2.25 6.62 2.25 12C2.25 17.38 6.62 21.75 12 21.75C17.38 21.75 21.75 17.38 21.75 12C21.75 6.62 17.38 2.25 12 2.25ZM12 20.25C7.45 20.25 3.75 16.55 3.75 12C3.75 7.45 7.45 3.75 12 3.75C16.55 3.75 20.25 7.45 20.25 12C20.25 16.55 16.55 20.25 12 20.25Z",
    fill: "#01B66A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4704 9.46994L11.0004 13.9399L8.53043 11.4699C8.24043 11.1799 7.76043 11.1799 7.47043 11.4699C7.18043 11.7599 7.18043 12.2399 7.47043 12.5299L10.4704 15.5299C10.6204 15.6799 10.8104 15.7499 11.0004 15.7499C11.1904 15.7499 11.3804 15.6799 11.5304 15.5299L16.5304 10.5299C16.8204 10.2399 16.8204 9.75994 16.5304 9.46994C16.2404 9.17994 15.7604 9.17994 15.4704 9.46994Z",
    fill: "#01B66A"
  })));
};
export default SvgSuccess;